import useApi from '../api';

const useWAUService = () => {
    const { api } = useApi();

    return {
        getWAU: (weeks, enterprises) =>
            api.get('WAU_milk', { params: { week: weeks, enterprise_id: enterprises } }).then((resp) => resp.data),

        storeRedisData: (data) => api.post('WAU_milk', data),

        getCSList: (enterprises, status, perPage, page) =>
            api
                .get('WAU_milk/CS', { params: { enterprise_id: enterprises, status: status, per_page: perPage, page: page } })
                .then((resp) => resp.data)
    };
};

export default useWAUService;
